/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { cssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import type { Caption as OriginalCaption } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

const styles = cssMap({
	caption: {
		marginTop: token('space.100'),
		textAlign: 'center',
		position: 'relative',
		color: token('color.text.subtle'),
	},
});

export const Caption = ({
	children,
	dataAttributes,
	lightNodeRef,
}: Pick<ComponentProps<typeof OriginalCaption>, 'children' | 'dataAttributes'> &
	LightNodeProps): ReactElement => (
	<div {...dataAttributes} ref={lightNodeRef} data-media-caption css={styles.caption}>
		{children}
	</div>
);
